import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { NotificationBannerContainerComponent } from '../hub-banner/notification-banner-container.component';
import { NotificationBannerStandardComponent } from '../hub-banner/notification-banner-standard.component';
import { IconCloseComponent } from '../icon-close/icon-close.component';
import { IconPaperlessComponent } from '../hub-banner/icon-paperless.component';
import { OptInBannerComponent } from './opt-in-banner.component';
import { OptInModalComponent } from './opt-in-modal.component';
import { OptInModalDisclosureComponent } from './opt-in-modal-disclosure.component';

@NgModule({
  declarations: [
    OptInBannerComponent,
    OptInModalComponent,
    OptInModalDisclosureComponent,
    NotificationBannerContainerComponent,
    IconPaperlessComponent,
  ],
  imports: [CommonModule, MatDialogModule, RouterModule, NotificationBannerStandardComponent, IconCloseComponent],
  exports: [
    OptInBannerComponent,
    OptInModalComponent,
    OptInModalDisclosureComponent,
    NotificationBannerContainerComponent,
  ],
})
export class OptInUiModule {}
